import { MusicFileUpload2Icon, MusicFileUploadIcon } from '@/components/Icons';
import Show from '@/components/Show';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { R3imagineStatusType } from '@/state/generator-store';
import { cn } from '@/utils';

type UploadAreaProps = {
  isDragging: boolean;
  showNewGenerator: boolean;
  fileInputRef: React.RefObject<HTMLInputElement>;
  onFileUpload: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onClickUpload: () => void;
  r3ImageStatus: R3imagineStatusType;
};

export const UploadArea: React.FC<UploadAreaProps> = ({
  r3ImageStatus,
  isDragging,
  showNewGenerator,
  fileInputRef,
  onFileUpload,
  onClickUpload,
}) => {
  if (showNewGenerator) {
    return (
      <div
        className={cn(
          'relative flex min-h-[160px] h-full w-full cursor-pointer flex-col items-center justify-center rounded-lg border-jen-orange [border-style:dashed] [border-width:1px] [border-dash:14px] [border-spacing:20px] text-center',
          isDragging && 'border-white',
        )}
        onClick={onClickUpload}
      >
        <input ref={fileInputRef} onChange={onFileUpload} accept="audio/*" type="file" className="hidden" />
        <MusicFileUpload2Icon className="text-jen-orange" />
        <h3 className="mt-4 text-3xl font-medium text-white">
          <Show when={r3ImageStatus === R3imagineStatusType.WaitingUpload}>
            <>
              Drag and drop or <span className="text-jen-orange underline decoration-jen-orange underline-offset-4">upload a file</span>
            </>
          </Show>
          <Show when={r3ImageStatus === R3imagineStatusType.UploadLoading}>
            <>
              <div>Uploading...</div>
            </>
          </Show>
        </h3>
      </div>
    );
  }

  return (
    <>
      <MusicFileUploadIcon className="w-16 h-16 text-white" />
      <p className="text-white">{isDragging ? 'Drop file here' : 'Drag and drop or upload a file'}</p>
      <Input type="file" className="hidden" ref={fileInputRef} onChange={onFileUpload} accept="audio/*" />
      <Button variant="outline" type="button" onClick={onClickUpload} className="text-white">
        UPLOAD
      </Button>
    </>
  );
};
